export const SAVE_COGNITO_USER = 'SAVE_COGNITO_USER';

export const saveCognitoUser = cognitoUserId => dispatch => {
  dispatch({ type: SAVE_COGNITO_USER });
  return dispatch({
    type: SAVE_COGNITO_USER,
    payload: cognitoUserId
  });
};
